<template>
  <v-dialog
    v-bind="$attrs"
    v-model="dialog"
    :overlay="false"
    transition="dialog-transition"
    :max-width="tamanhos.length > 1 ? 620 : 500"
    overlay-opacity="0.8"
    content-class="ma-2"
  >
    <v-card :max-width="tamanhos.length > 1 ? 620 : 436" class="pa-0">
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Quantas unidades?</v-toolbar-title>
      </v-app-bar>

      <v-row class="mx-2">
        <label
          style="position: absolute !important; top: 122px; left: 16px; color: red"
          >{{ error }}</label
        >
        <v-col cols="5" sm="4" md="4" lg="4" class="pa-2 pb-4">
          <span>Quantidade</span>
          <v-combobox
            v-model="quantidade"
            :value="quantidade"
            :items="opcoes_quantidade"
            solo
            dense
            hide-details
            type="text"
            @blur="trimText"
            @keydown="update"
            @change="calcularSubtotal"
          ></v-combobox>
        </v-col>
        <v-col
          cols="2"
          sm="1"
          md="1"
          lg="1"
          class="pa-2 pt-8 pb-4"
          style="align-items: center; display: flex; justify-content: center; pointer-events: none"
        >
          <span>X</span>
        </v-col>
        <v-col
          cols="5"
          sm="3"
          md="3"
          lg="3"
          class="pa-2 pb-4"
          style="pointer-events: none"
        >
          <span>Valor</span>
          <v-text-field
            solo
            :value="'R$ ' + valorBR(valor)"
            readonly
            dense
            hide-details
            background-color="grey lighten-2"
            class="direita"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="4"
          lg="4"
          class="pa-2 pb-3"
          style="pointer-events: none"
        >
          <span>Subtotal</span>
          <v-text-field
            solo
            :value="'R$ ' + valorBR(subtotal)"
            readonly
            dense
            hide-details
            dark
            class="direita"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="processando" class="mx-2">
        <v-col class="pa-2 pb-4">
          <v-progress-linear
            color="accent"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
      <v-row v-show="!processando" class="mx-2">
        <v-col class="pa-2 pb-4" v-if="tamanhos.length > 1 || cores.length > 1">
          <v-row
            class="ma-0 pa-0 pb-2"
            style="display: flex; align-items: flex-end;"
          >
            <v-col cols="12" sm="4" md="4" lg="4" class="pa-0">
              <v-checkbox
                v-model="todosSelecionados"
                :indeterminate="todosSelecionados === null"
                label="Selecionar tudo"
                class="pa-0 ma-0"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="6" sm="5" md="5" lg="5" class="pa-0">
              <v-checkbox
                v-model="rateioAutomatico"
                label="Rateio automático"
                class="pa-0 ma-0 pt-3"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col
              v-if="!rateioAutomatico"
              cols="6"
              sm="3"
              md="3"
              lg="3"
              class="pa-0"
              style="text-align: end"
            >
              <v-btn depressed @click="ratear">Ratear</v-btn>
            </v-col>
          </v-row>
          <v-card>
            <v-col class="pa-0" style="display: flex">
              <div
                class="gradeContainer"
                id="gradeContainer"
                @scroll="handleScroll"
                :style="
                  `height:${(cores.length + 1) * 37}px; max-height: ${
                    (cores.length + 1) * 37 > 220
                      ? '220'
                      : (cores.length + 1) * 37
                  }px;`
                "
              >
                <table class="tableX">
                  <thead>
                    <tr>
                      <th
                        :style="
                          `background: black; text-align: center; padding: 8px 8px 8px 16px; width:${
                            tamanhos.length === 1 ? '220' : '180'
                          }px`
                        "
                      >
                        Cores
                      </th>
                      <th
                        v-for="tamanho in tamanhos"
                        :key="tamanho.id"
                        :style="`background: black; text-align: center`"
                      >
                        <v-checkbox
                          class="ma-0 pa-0"
                          :label="tamanho.tamanho"
                          :disabled="tamanhos.length === 1"
                          dark
                          hide-details
                          dense
                          :id="`${idWindow}tam-${tamanho.id}`"
                          :name="`${idWindow}tam-${tamanho.id}`"
                          v-model="tamanho.selected"
                          @click.native="selectTamanho"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(cor, idx) in cores" :key="cor.id">
                      <th
                        :style="
                          idx % 2
                            ? 'color: black; text-align: center; background: white'
                            : 'color: black; text-align: center; background: #f5f5f5'
                        "
                      >
                        <v-checkbox
                          :label="cor.nome"
                          :disabled="cores.length === 1"
                          class="ma-0 pa-0"
                          style="font-weight: 400"
                          hide-details
                          dense
                          :id="`${idWindow}cor-${cor.id}`"
                          :name="`${idWindow}cor-${cor.id}`"
                          v-model="cor.selected"
                          @click.native="selectCor"
                        ></v-checkbox>
                      </th>
                      <td
                        :style="
                          `text-align: center; cursor: ${
                            rateioAutomatico ? 'default' : 'auto'
                          }; pointer-events: ${
                            rateioAutomatico ? 'none' : 'all'
                          }`
                        "
                        v-for="tamanho in tamanhos"
                        :key="tamanho.id"
                      >
                        <input
                          :disabled="!tamanho.selected || !cor.selected"
                          @focus="enterInput"
                          @blur="blurInput"
                          class="customInput"
                          type="number"
                          :name="`${idWindow}-${cor.id}-${tamanho.id}`"
                          :id="`${idWindow}-${cor.id}-${tamanho.id}`"
                          :style="
                            `outline: none; text-align: center; cursor: ${
                              rateioAutomatico ? 'default' : 'auto'
                            };`
                          "
                          v-on:keyup.enter="nextCell"
                          @change="setQuantidade"
                          @wheel="$event.currentTarget.blur()"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-card>
          <v-col
            class="pa-0 pt-1"
            style="display: flex; justify-content: flex-end;"
          >
            <v-btn x-small @click="scroll(0, 36)">
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
            <v-btn x-small @click="scroll(0, -36)">
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
            <v-btn x-small @click="scroll(-200, 0)">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn x-small @click="scroll(200, 0)">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
          <small
            class="mt-2"
            style="width: 100%; display: block; text-align: justify"
          >
            <ul>
              <li>
                Selecione as cores e os tamanhos que desejar e preencha a
                quantidade de cada cor e tamanho
              </li>
              <li>
                Ou simplemente preencha a quantidade total e selecione
                <b>Rateio Automático</b>
                <br />Vamos ratear a quantidade para todos os tamanhos e cores
                que você selecionar
              </li>
            </ul>
          </small>
        </v-col>

        <v-col
          class="pa-2 pt-0 pb-3"
          style="display: flex; align-items: flex-end; justify-content: flex-end;"
        >
          <label style="color: red">{{ errorSalvar }}</label>
          <v-btn depressed height="38" @click="fechar" :disabled="loading"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            class="ml-4"
            height="38"
            @click="salvar"
            :loading="loading"
            :disabled="loading"
            >Ok</v-btn
          >
        </v-col>

        <v-col
          v-if="$vuetify.breakpoint.xsOnly && error"
          cols="12"
          class="pa-2"
          style="color: red"
          >{{ error }}</v-col
        >
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import ServiceProdutos from "@/services/produtos.js";

export default {
  name: "tamanhos-cores",
  props: {
    fecharDetalhe: {
      type: Function,
    },
    idWindow: {
      type: String,
    },
  },

  data() {
    return {
      dialog: false,
      error: "",
      errorSalvar: "",
      show: false,
      quantidade: null,
      valor: 0,
      subtotal: 0,
      quantidadeMinima: 0,
      loading: false,
      cores: [],
      tamanhos: [],
      grade: [],
      todosSelecionados: false,
      rateioAutomatico: false,
      processando: false,
      edicao: false,
      produto: {},
      opcoes_quantidade: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
    };
  },

  methods: {
    scroll(x, y) {
      document
        .getElementById("gradeContainer")
        .scrollBy({ left: x, top: y, behavior: "smooth" });
    },

    update(event) {
      const { target } = event;
      setTimeout(() => {
        this.calcularSubtotal(
          (target.value && target.value.replace(/[^0-9]+/g, "")) || "0"
        );
        if (this.rateioAutomatico) {
          this.ratear();
        }
      }, 100);
    },

    async abrir(produto) {
      this.dialog = true;

      if (this.produto.id !== produto.id) {
        this.processando = true;
        this.produto = produto;

        const { data } = await ServiceProdutos.grade(produto.id);

        if (data) {
          this.cores = data.cores.map((cor) => ({
            ...cor,
            selected: data.cores.length === 1,
          }));
          this.tamanhos = data.tamanhos.map((tam) => ({
            ...tam,
            selected: data.tamanhos.length === 1,
          }));
          const temp = [];
          this.cores.forEach((cor) => {
            this.tamanhos.forEach((tam) => {
              temp.push({
                corId: cor.id,
                tamanhoId: tam.id,
                quantidade: null,
              });
            });
          });
          this.grade = [...temp];
          this.todosSelecionados = false;
          this.rateioAutomatico = false;
          this.valor = produto.valor;
          this.subtotal = 0;
          this.quantidade = 0;
          this.quantidadeMinima = produto.quantidade_minima || 0;
          this.error = "";
          this.loading = false;

          this.quantidade = produto.quantidade_minima;
          this.$nextTick(() => {
            this.verificarProdutoExisteCarrinho();
          });
        } else {
          const produtoCarrinho = this.$store.state.produtos.find(
            (produto) => produto.id === this.produto.id
          );
          const qtd = this.grade.reduce(
            (total, grade) => total + grade.quantidade,
            0
          );

          if (!produtoCarrinho && qtd > 0) {
            this.cores = data.cores.map((cor) => ({
              ...cor,
              selected: data.cores.length === 1,
            }));
            this.tamanhos = data.tamanhos.map((tam) => ({
              ...tam,
              selected: data.tamanhos.length === 1,
            }));
            const temp = [];
            this.cores.forEach((cor) => {
              this.tamanhos.forEach((tam) => {
                temp.push({
                  corId: cor.id,
                  tamanhoId: tam.id,
                  quantidade: null,
                });
              });
            });
            this.grade = [...temp];
            this.todosSelecionados = false;
            this.rateioAutomatico = false;
            this.valor = produto.valor;
            this.subtotal = 0;
            this.quantidade = 0;
            this.quantidadeMinima = produto.quantidade_minima || 0;
            this.error = "";
            this.loading = false;

            this.quantidade = produto.quantidade_minima;
            this.subtotal =
              this.valorUS(this.valor) * parseInt(this.quantidade);
          }

          this.processando = false;
        }

        if (this.produto.multiplo) {
          let opcoes_multiplo = [];

          for (let i = 1; opcoes_multiplo.length < 10; i++) {
            let qtd_loop = this.produto.multiplo * i;
            qtd_loop >= this.produto.quantidade_minima
              ? opcoes_multiplo.push(qtd_loop)
              : "";
          }

          this.opcoes_quantidade = opcoes_multiplo;
        } else {
          this.opcoes_quantidade = [
            100,
            200,
            300,
            400,
            500,
            600,
            700,
            800,
            900,
            1000,
          ];
        }
      }
    },

    fechar() {
      this.dialog = false;
      this.zerar();
    },

    trimText() {
      setTimeout(() => {
        if (typeof this.quantidade === "string") {
          this.quantidade =
            (this.quantidade && this.quantidade.replace(/[^0-9]+/g, "")) || "0";
          if (this.rateioAutomatico) {
            this.ratear();
          }
          this.calcularSubtotal();
        } else {
          this.calcularSubtotal();
        }
      }, 200);
    },

    calcularSubtotal(value) {
      if (this.rateioAutomatico) {
        this.ratear();
      }
      this.subtotal =
        this.valorUS(this.valor) * parseInt(value || this.quantidade);
    },

    ratear() {
      this.processando = true;
      const totalCores = this.cores.filter((cor) => cor.selected).length;
      const totalTamanhos = this.tamanhos.filter((tam) => tam.selected).length;

      if (
        totalCores === this.cores.length &&
        totalTamanhos === this.tamanhos.length
      ) {
        this.todosSelecionados = true;
      } else if (totalCores === 0 && totalTamanhos === 0) {
        this.todosSelecionados = false;
      } else {
        this.todosSelecionados = null;
      }

      const rateio = Math.floor(
        parseInt(this.quantidade) / (totalCores * totalTamanhos)
      );

      let resto = parseInt(this.quantidade) % (totalCores * totalTamanhos);

      let temp = 0;

      let lastGrade = null;

      this.grade.forEach((grade) => {
        const corGrade = this.cores.find((cor) => cor.id === grade.corId);
        const tamGrade = this.tamanhos.find(
          (tam) => tam.id === grade.tamanhoId
        );
        const el = document.getElementById(
          `${this.idWindow}-${grade.corId}-${grade.tamanhoId}`
        );
        if (corGrade.selected && tamGrade.selected) {
          el.value = rateio + (resto > 0 ? 1 : 0);
          temp += parseInt(el.value);
          grade.quantidade = parseInt(el.value);
          resto = resto - (resto > 0 ? 1 : 0);
          lastGrade = grade;
        } else if (el) {
          el.value = null;
          grade.quantidade = null;
        }
      });

      if (resto > 0) {
        const el = document.getElementById(
          `${lastGrade.corId}-${lastGrade.tamanhoId}`
        );
        if (el) {
          el.value = parseInt(el.value) + resto;
          lastGrade.quantidade = parseInt(el.value);
        }
      }
      this.processando = false;
    },

    validarQuantidade() {
      if (this.tamanhos.length === 1 && this.cores.length === 1) {
        this.grade[0].quantidade = this.quantidade;
      }

      const qtd = this.grade.reduce(
        (total, grade) => total + grade.quantidade,
        0
      );

      setTimeout(() => {
        this.error = "";
        this.errorSalvar = "";
      }, 5000);

      if (isNaN(parseInt(this.quantidade))) {
        this.error = "Quantidade inválida";
        return false;
      } else if (
        this.$auth.user.tipo !== "fornecedor" &&
        parseInt(this.quantidade) < this.quantidadeMinima
      ) {
        this.error = "Quantidade mínima: " + this.quantidadeMinima;
        return false;
      } else if (parseInt(this.quantidade) > 0) {
        if (parseInt(qtd) !== parseInt(this.quantidade)) {
          this.errorSalvar =
            "Quantidade total diferente da quantidade rateada nas cores/tamanhos";
          return false;
        } else if (
          this.produto.multiplo &&
          this.quantidade % this.produto.multiplo != 0
        ) {
          this.errorSalvar = `A quantidade selecionada para este produto deve ser um mútiplo de ${this.produto.multiplo}`;
          return false;
        } else {
          this.errorSalvar = "";
          this.error = "";
          return true;
        }
      }
    },

    nextCell(event) {
      let element = event.target.parentElement;
      if (element.nextElementSibling) {
        element.nextElementSibling.firstChild.focus();
      } else {
        element = element.parentElement.nextElementSibling;
        if (element) {
          element.firstChild.nextElementSibling.firstChild.focus();
        }
      }
    },

    blurInput(event) {
      event.target.parentElement.style.backgroundColor = "transparent";
    },

    enterInput(event) {
      event.target.parentElement.style.background = "lightgrey";
    },

    setQuantidade(event) {
      if (!this.rateioAutomatico) {
        this.processando = true;
        const { target } = event;
        if (target.name && target.value > 0) {
          const corTam = target.name.split("-");
          const found = this.grade.find(
            (grade) =>
              grade.corId === parseInt(corTam[1]) &&
              grade.tamanhoId === parseInt(corTam[2])
          );
          found.quantidade = parseInt(target.value);
          const quantidadeTotal = this.grade.reduce(
            (total, grade) => total + grade.quantidade,
            0
          );
          this.quantidade = quantidadeTotal;
          this.calcularSubtotal();
        }
        this.processando = false;
      }
    },

    selectCor(event) {
      const { target } = event;
      const check = target.previousElementSibling;
      this.cores = this.cores.map((cor) =>
        `${this.idWindow}cor-${cor.id}` == check.id
          ? { ...cor, selected: check.checked }
          : cor
      );
      if (!check.checked) {
        this.grade = this.grade.map((grade) => {
          if (`${this.idWindow}cor-${grade.corId}` === check.id) {
            const el = document.getElementById(
              `${this.idWindow}-${grade.corId}-${grade.tamanhoId}`
            );
            el.value = null;
          }
          return `${this.idWindow}cor-${grade.corId}` == check.id
            ? { ...grade, quantidade: null }
            : grade;
        });
      }
      if (this.rateioAutomatico) {
        this.ratear();
      }
    },

    selectTamanho(event) {
      const { target } = event;
      const check = target.previousElementSibling;
      this.tamanhos = this.tamanhos.map((tam) =>
        `${this.idWindow}tam-${tam.id}` == check.id
          ? { ...tam, selected: check.checked }
          : tam
      );
      if (!check.checked) {
        this.grade = this.grade.map((grade) => {
          if (`${this.idWindow}tam-${grade.tamanhoId}` === check.id) {
            const el = document.getElementById(
              `${this.idWindow}-${grade.corId}-${grade.tamanhoId}`
            );
            el.value = null;
          }
          return `${this.idWindow}tam-${grade.tamanhoId}` == check.id
            ? { ...grade, quantidade: null }
            : grade;
        });
      }
      if (this.rateioAutomatico) {
        this.ratear();
      }
    },

    salvar() {
      this.loading = true;
      this.processando = true;
      setTimeout(() => {
        if (this.validarQuantidade()) {
          //procura o indice do produto atual no carrinho
          let index = this.$store.state.produtos.findIndex(
            (produto) => produto.id == this.produto.id
          );

          if (index > -1) {
            // produto já existe no carrinho, remove o produto para adicionar depois
            this.$store.commit("removerItemCarrinho", index);
          }

          this.$store.commit("adicionarItemCarrinho", {
            ...this.produto,
            quantidade: this.quantidade,
            valor: this.valor,
            subtotal: this.subtotal,
            grade: this.grade,
          });

          if (this.fecharDetalhe) {
            this.fecharDetalhe();
          }
          this.$eventbus.notificar("Produto adicionado ao carrinho");
          this.fechar();
          this.loading = false;
          this.processando = false;
        } else {
          this.loading = false;
          this.processando = false;
        }
      }, 300);
    },

    handleScroll(event) {
      const { target } = event;
      // Implementar Virtual Scroller
      // console.log(
      //   target.clientHeight,
      //   target.clientWidth,
      //   target.scrollHeight,
      //   target.scrollWidth,
      //   target.scrollTop,
      //   target.scrollLeft
      // );
    },

    verificarProdutoExisteCarrinho() {
      this.processando = true;
      const produtoCarrinho = this.$store.state.produtos.find(
        (produto) => produto.id === this.produto.id
      );

      if (produtoCarrinho) {
        let selecionados = 0;
        let total = 0;

        this.grade = this.grade.map((grade) => {
          const tamCor = produtoCarrinho.grade.find(
            (item) =>
              item.corId == grade.corId && item.tamanhoId == grade.tamanhoId
          );

          if (tamCor) {
            const tam = this.tamanhos.find(
              (item) => item.id == tamCor.tamanhoId
            );
            if (tam && tamCor.quantidade) {
              tam.selected = true;
            }
            const cor = this.cores.find((item) => item.id == tamCor.corId);
            if (cor && tamCor.quantidade) {
              cor.selected = true;
            }

            const el = document.getElementById(
              `${this.idWindow}-${grade.corId}-${grade.tamanhoId}`
            );

            if (el) {
              if (tamCor.quantidade) {
                selecionados += 1;
                total += tamCor.quantidade;
              }
              el.value = tamCor.quantidade || null;
            }
          }

          return tamCor ? { ...grade, quantidade: tamCor.quantidade } : grade;
        });

        this.quantidade = total;
        this.todosSelecionados = this.grade.length == selecionados;
      }
      this.subtotal = this.valorUS(this.valor) * parseInt(this.quantidade);
      this.processando = false;
    },
    zerar() {
      this.grade.forEach((grade_atual) => {
        let element = document.getElementById(
          this.idWindow + "-" + grade_atual.corId + "-" + grade_atual.tamanhoId
        );
        element.value = null;
      });
    },
  },
  watch: {
    rateioAutomatico: {
      handler: function(value) {
        if (value) {
          this.ratear();
        }
      },
    },
    todosSelecionados: {
      handler: function(value) {
        if ((value || value === false) && !this.processando) {
          this.tamanhos = this.tamanhos.map((tam) => {
            const el = document.getElementById(`${this.idWindow}tam-${tam.id}`);
            if (el) {
              el.checked = value;
            }
            return { ...tam, selected: value };
          });
          this.cores = this.cores.map((cor) => {
            const el = document.getElementById(`${this.idWindow}cor-${cor.id}`);
            if (el) {
              el.checked = value;
            }
            return { ...cor, selected: value };
          });
          if (this.rateioAutomatico) {
            this.ratear();
          }
        }
      },
    },
  },
};
</script>

<style lang="css" scoped>
.direita.v-input >>> input {
  text-align: right !important;
}

.gradeContainer {
  max-width: 100%;
  overflow: scroll;
  overflow-y: scroll;
  overflow-x: scroll;
  position: relative;
  -ms-overflow-style: none;
  scrollbar-width: none;
  border-radius: 0px 0px 0px 4px;
  /* overflow: overlay; */
}

.gradeContainer::-webkit-scrollbar {
  display: none;
}

.tableX {
  position: relative;
  border-collapse: collapse;
}

td,
th {
  padding: 4px 8px;
  border-right: 1px solid #dddddd;
}

.tableX tr:nth-child(odd) {
  background: #f5f5f5;
}

.tableX th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  color: white;
  padding: 6px 8px;
  /* min-width: 80px; */
}

.tableX th >>> label {
  text-align: center !important;
  display: block !important;
  padding-right: 24px;
}

.tableX thead th:first-child {
  box-shadow: inset 1px 0 0 white, inset -1px 0 0 white;
  border-radius: 4px 0px 0px 0px;
  min-width: 180px;
  left: 0;
  color: white;
  z-index: 1;
}

.tableX thead th:last-child {
  border-radius: 0px 4px 0px 0px;
  border-right: none;
}

.tableX tbody th {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
  box-shadow: inset 1px 0 0 #ccc, inset -1px 0 0 #ccc;
}

.customInput::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.customInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.customInput[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}

.customInput:disabled {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIklEQVQIW2NkQAKrVq36zwjjgzhhYWGMYAEYB8RmROaABADeOQ8CXl/xfgAAAABJRU5ErkJggg==)
    repeat;
}
</style>
